import React, { useState } from 'react';
import { Link2, Check } from 'lucide-react';
import { toast } from 'sonner';

export const configUrl = (piece, config) =>
  `${window.location.origin}/product/${piece.slug}?stone=${config.stone}&metal=${config.metal}`;

export const ShareConfig = ({ realm, piece, config, variant = 'text' }) => {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    const url = configUrl(piece, config);
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      window.prompt('Copy this link', url);
    }
    setCopied(true);
    toast('Link copied', { description: realm.interest(piece, config.metal, config.stone) });
    setTimeout(() => setCopied(false), 2200);
  };

  const Icon = copied ? Check : Link2;
  return (
    <button
      type="button"
      className={`ashare ashare--${variant} ${copied ? 'is-copied' : ''}`}
      onClick={copy}
      aria-label="Copy a link to this configuration"
      title="Copy a link to this configuration"
      data-testid={`share-config-${variant}`}
    >
      <Icon className="w-3.5 h-3.5" strokeWidth={1.25} />
      {variant === 'text' && <span>{copied ? 'Link copied' : 'Share this configuration'}</span>}
    </button>
  );
};
